import { render } from "./ElDesktopNavigation.vue?vue&type=template&id=99e099b6&lang=html"
import script from "./ElDesktopNavigation.vue?vue&type=script&lang=js"
export * from "./ElDesktopNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__